const LOG_PREFIX = "[OCM][Custom] "
const StoryTeller = require('../../services/story_teller')
//const InstreamHB = require('../../services/instream_hb')
const Aniview = require('../../services/aniview')


let customCode = (utils) => {
  return new Promise((resolve, reject) => {
    utils.loadStyle('.adv {min-height:300px; margin:10px auto; background-color:#f5f5f5;} .adv-xl {min-height:400px;}')

    if (utils.is_mobile && utils.getParameterByName('helleniq') == '1') {
      utils.loadScript('https://bs.serving-sys.com/Serving/adServer.bs?c=28&cn=display&pli=1078520346&gdpr=${GDPR}&gdpr_consent=${GDPR_CONSENT_68}&w=1&h=1&ncu=$$%%CLICK_URL_UNESC%%$$&ord=%%CACHEBUSTER%%&z=0', 'text/javascript')
    }

    utils.contentLoaded().then(() => {
      if (window.OCM.pageType === 'Article') {
        		runOutstream(utils, document.getElementById('ocm-outstream-wrapper'))
      }
    })

    if (utils.getParameterByName('ocm_st') == 1 && window.OCM.pageType === 'Article') {
      utils.config.services.story_teller.active = true
      const st = new StoryTeller(utils, utils.config)
      st.run()
    }

    window.oopb = function() {

    }

    resolve(true)
  });
};

let runOutstream = (utils, selector) => {
  if (!selector) {
    return
  }

  //teads
  (function (w, d, s) {
    try {
      d = w.top.document || d;
      w = w.top.document ? w.top : w;
    } catch (e) {
    }

    let exclude_urls = [
      'food/133878_delivery-kai-lockdown-ta-agapimena-soy-burgers-erhontai-stin-porta-soy-apo-ta-goodys',
    ]

    for (var z = 0; z < exclude_urls.length; z++) {
      if (window.location.href.indexOf(exclude_urls[z]) > -1) {
        return
      }
    }

    var ttag = function () {
      w.teads.page(92896).placement(100649, {
        slider: {allow_corner_position: false, allow_top_position: false},
        "css": "",
        "format": "inread",
        "slot": {"insertInside": true, "selector": selector, "minimum": 0}
      }).passback(function () {
        console.log('running ishb');
      
        utils.config.services.aniview.active = true
        const av = new Aniview(utils, utils.config)
        av.run()
        
        window.OCM.oipb = () => {
          console.log('running oipb');
//           initVi(utils, selector)
          ocmPassback(selector, true);
        }
      }).serve();
    };
    if (w.teads && w.teads.page) {
      ttag();
    } else if (!w.teadsscript) {
      var protocol = w.location.protocol.match(/^https?:$/) ? w.location.protocol : 'https:';
      s.src = protocol + '//a.teads.tv/media/format/v3/teads-format.min.js';
      s.async = true;
      s.onload = ttag;
      w.teadsscript = d.getElementsByTagName('head')[0].appendChild(s);
    }
  })(window, document, document.createElement('script'));
}

let ocmPassback = (selector, insertInside = false) => {
  if (!selector) {
    return
  }

  selector.classList.remove('adv-xl')

  googletag.cmd.push(function() {
    let inread = googletag.sizeMapping()
    .addSize([0,0], [[300,250]])
    .addSize([400,0], [[300,250],[336,280]])
    .addSize([768,0], [[300,250], [336,280],[1,1],[640,360],[640,380],'fluid'])
    .build();
    
    googletag.defineSlot('/21771721121/ethnos.gr/inread_pb',[[300,250],[336,280]],'ocm-outstream').defineSizeMapping(inread).addService(googletag.pubads());
    var outstream_div = document.createElement('div');
    outstream_div.id = 'ocm-outstream';
    var outstream_script = document.createElement('script');
    outstream_script.text = 'googletag.cmd.push(function(){ googletag.display("ocm-outstream"); })';
    if (insertInside) {
      selector.append(outstream_div);
    } else {
      selector.parentNode.insertBefore(outstream_div, selector.nextElementSibling);
    }
    outstream_div.append(outstream_script);
  });
}

let initVi = (utils, slot) => {
  utils.loadStyle('#vi-stories-sponsor-container {display: none!important;}');

  var vidiv = document.createElement('div');
  vidiv.id = 'vi-div';
  if (!utils.is_mobile) {
    vidiv.style.width = '80%';
  }
  vidiv.style.margin = '0 auto 1rem';

  if (slot) {
    slot.append(vidiv);
  }

  (function (v, i) {
    var scp = v.createElement("script"),
        config = {
          ChannelID: '5d8390ef28a0611e523a52aa',
          AdUnitType: '2',
          PublisherID: '133044126840134',
          PlacementID: 'pltz9FljnNNm8YU6PEn',
          DivID: 'vi-div',
          IAB_Category: 'IAB1',
          Keywords: '',
          Language: 'en-us',
          BG_Color: '',
          Text_Color: '',
          Font: '',
          FontSize: '',
        };
    scp.src = 'https://s.vi-serve.com/tagLoader.js';
    scp.type = "text/javascript";
    scp.onload = function () {
      i[btoa('video intelligence start')].init(config);
    };
    (v.getElementsByTagName('head')[0] || v.documentElement.appendChild(v.createElement('head'))).appendChild(scp);
  })(document, window);
}

module.exports = customCode;